'use client'

import { createContext, useContext } from 'react'

const ClientProvidersReadyContext = createContext(true)

export function ClientProvidersReadyProvider({
  ready,
  children
}: {
  ready: boolean
  children: React.ReactNode
}) {
  return (
    <ClientProvidersReadyContext.Provider value={ready}>
      {children}
    </ClientProvidersReadyContext.Provider>
  )
}

export function useClientProvidersReady(): boolean {
  return useContext(ClientProvidersReadyContext)
}
